var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#8B93A7",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    transform: "translate(9.818479, 9.828571) rotate(-45.000000) translate(-9.818479, -9.828571) ",
    points: "13.9327648 5.71428531 13.9327648 13.9428571 5.70419301 13.9428571"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.81847889,
    y1: 15.6470501,
    x2: 9.81847889,
    y2: 4.0100923,
    id: "Path-3",
    stroke: "#8B93A7",
    strokeWidth: 1.2,
    transform: "translate(9.818479, 9.828571) rotate(-90.000000) translate(-9.818479, -9.828571) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9d68b3a1080485074bf5d16896342ea7.svg";
export { ForwardRef as ReactComponent };